import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "编辑项目",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submit
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" 保存 ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
            class: "demo-tabs",
            onTabClick: _ctx.handleClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "项目信息",
                name: "projectInfo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    ref: "formRef1",
                    model: _ctx.projectData,
                    "label-width": "100px",
                    rules: _ctx.projectRules
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData, (i, index) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: index,
                          label: i.name,
                          prop: `${i.prop}.value`
                        }, {
                          default: _withCtx(() => [
                            (i.type === 'input')
                              ? (_openBlock(), _createBlock(_component_el_input, {
                                  key: 0,
                                  modelValue: i.value,
                                  "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
                                  type: i.type || 'text',
                                  placeholder: i.placeholder || '请输入'
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "placeholder"]))
                              : _createCommentVNode("", true),
                            (i.type === 'select')
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 1,
                                  class: "w-full",
                                  modelValue: i.value,
                                  "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
                                  multiple: i.multiple,
                                  placeholder: "请选择"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item[i.defaultAttrs.value],
                                        label: item[i.defaultAttrs.label],
                                        value: item[i.defaultAttrs.value]
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "multiple"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["label", "prop"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "考勤信息",
                name: "attendanceInfo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    ref: "formRef2",
                    model: _ctx.attendanceData,
                    "label-width": "100px",
                    rules: _ctx.attendanceRules
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendanceData, (i, index) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: index,
                          label: i.name,
                          prop: `${i.prop}.value`
                        }, {
                          default: _withCtx(() => [
                            (i.type === 'radio')
                              ? (_openBlock(), _createBlock(_component_el_radio_group, {
                                  key: 0,
                                  modelValue: i.value,
                                  "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
                                  class: "ml-4"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.options, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_radio, {
                                        key: index,
                                        label: item.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (i.type === 'select')
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 1,
                                  class: "w-full",
                                  modelValue: i.value,
                                  "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
                                  multiple: i.multiple,
                                  placeholder: "请选择"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item[i.defaultAttrs.value],
                                        label: item[i.defaultAttrs.label],
                                        value: item[i.defaultAttrs.value]
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "multiple"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["label", "prop"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onTabClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}